import "./resume.scss"

export default function Resume() {
    return <div className="resume-root">
        <a href={require("./assets/Josh_Huang_Resume_2023.pdf")} target='_blank'>Open Resume Manually</a>
        <iframe src={require("./assets/Josh_Huang_Resume_2023.pdf#toolbar=0")} width="1200px" height="1200px" title={"resume"}/>
    </div>
}